<template>
  <div id="preloader">
    <div class="wrapper px-5">
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1080 1080"
        id="preloader-animation"
      >
        <rect id="rect1" x="0.4" y="-3.1" width="195.5" height="195.5" />

        <rect id="rect2" x="0.4" y="293.5" width="195.5" height="195.5" />

        <rect id="rect3" x="0.4" y="590.2" width="195.5" height="195.5" />

        <rect id="rect4" x="0.4" y="886.9" width="195.5" height="195.5" />

        <rect id="rect5" x="298.4" y="-3.1" width="195.5" height="195.5" />

        <rect id="rect6" x="298.4" y="293.5" width="195.5" height="195.5" />

        <rect id="rect7" x="298.4" y="590.2" width="195.5" height="195.5" />

        <rect id="rect8" x="298.4" y="886.9" width="195.5" height="195.5" />

        <rect id="rect9" x="596.4" y="-3.1" width="195.5" height="195.5" />

        <rect id="rect10" x="596.4" y="293.5" width="195.5" height="195.5" />

        <rect id="rect11" x="596.4" y="590.2" width="195.5" height="195.5" />

        <rect id="rect12" x="596.4" y="886.9" width="195.5" height="195.5" />

        <rect id="rect13" x="884.9" y="-3.1" width="195.5" height="195.5" />

        <rect id="rect14" x="884.9" y="293.5" width="195.5" height="195.5" />

        <rect id="rect15" x="884.9" y="590.2" width="195.5" height="195.5" />

        <rect id="rect16" x="884.9" y="886.9" width="195.5" height="195.5" />
      </svg>
      <h5 class="mt-5 text-center">
        <vue-typer
          v-if="key != 4"
          ref="vueTyper"
          class="no-wrap"
          :text="[
            `${
              key == 0 ? 'Loading your content. Please wait...' : 'Loading...'
            }`,
            `${key == 0 ? 'While you wait. Do you wanna hear a joke?' : ''}`,
            `${key == 0 ? 'Great. Check this out' : ' '}`,
            questions[randomNumber],
            answers[randomNumber]
          ]"
          :key="key"
          :repeat="0"
          initial-action="typing"
          :pre-type-delay="70"
          :type-delay="70"
          :pre-erase-delay="2000"
          :erase-delay="250"
          erase-style="select-all"
          :erase-on-complete="true"
          caret-animation="smooth"
          @completed="changeJoke"
        ></vue-typer>
        <vue-typer
          v-if="key == 4"
          ref="vueTyper"
          class="no-wrap"
          :text="[
            'Wow!',
            'Is it still loading?',
            'Gimme a second. Lemme run some tests',
            `Maybe you're on Netflix or something like that?`,
            'You can also try refreshing the browser.',
            'Or you can stay for the jokes'
          ]"
          :key="key"
          :repeat="0"
          initial-action="typing"
          :pre-type-delay="70"
          :type-delay="70"
          :pre-erase-delay="2000"
          :erase-delay="250"
          erase-style="select-all"
          :erase-on-complete="true"
          caret-animation="smooth"
          @completed="changeJoke"
        ></vue-typer>
      </h5>
    </div>
  </div>
</template>

<script>
import circles from "@/data/circles";
import shox from "@/data/shox";

// import Snap from "";

export default {
  data() {
    return {
      myTimer: null,
      count: 0,
      animations: [circles, shox],
      questions: [
        "What’s the best thing about Switzerland?",
        "Helvetica and Times New Roman walk into a bar.",
        "Hear about the new restaurant called Karma?",
        "Why don’t scientists trust atoms?",
        "Why did the chicken go to the séance?",
        "What did the left eye say to the right eye?",
        "Why can’t you hear a pterodactyl go to the bathroom?",
        "What did the buffalo say when his son left for college?",
        "Why did the yogurt go to the art exhibition?",
        "What do you call an apology written in dots and dashes?",
        "What do you get from a pampered cow?",
        "How many times can you subtract 10 from 100?",
        "How do you organise a space party?",
        "Oh and thanks for teaching me the meaning of 'Plethora'",
        "Do you know why I love whiteboards",
        "What's it called when you're scared of giants?"
      ],
      answers: [
        "I don't know but the flag is a big plus",
        "“Get out of here!” shouts the bartender. “We don’t serve your type.”",
        "There’s no menu: You get what you deserve.",
        "Because they make up everything",
        "To get to the other side.",
        "Between you and me. Something smells",
        "Because the “P” is silent.",
        "Bison.",
        "Because it was cultured.",
        "Re-Morse code. Ba dum tss",
        "Spoilt Milk",
        "Once. The next time you would be subtracting 10 from 90",
        "You planet",
        "It means a lot",
        "Because they are very remarkable",
        "Feefiphobia"
      ],
      randomNumber: 0,
      key: 0
    };
  },
  methods: {
    infiniteAnimation() {
      this.myTimer = setInterval(() => {
        this.count++;
        var index = this.count % this.animations.length;
        this.logoAnimation(this.animations[index]);
      }, 5500);
    },
    async logoAnimation(value) {
      const Snap = await import(
        "imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js"
      );
      value.forEach(rect => {
        var random = Math.random() * 2000;
        const anim = () => {
          Snap.select(rect.id).animate(
            {
              x: rect.x,
              y: rect.y,
              width: rect.width,
              height: rect.height
            },
            2000,
            window.mina.backout
          );
        };
        setTimeout(anim, random);
      });
    },
    changeJoke() {
      this.randomNumber = Math.floor(Math.random() * this.questions.length);
      //force an update of the vue-typer instance by changing the key
      this.key++;
    }
  },
  mounted() {
    this.infiniteAnimation();
    this.randomNumber = Math.floor(Math.random() * this.questions.length);
  },
  beforeDestroy() {
    clearInterval(this.myTimer);
  }
};
</script>

<style lang="scss" scoped>
/deep/ .vue-typer {
  color: #ffff;

  .custom.char {
    &.typed {
      color: $primary;
    }

    &.selected {
      background-color: transparent;
    }
  }
}

#preloader {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  z-index: 10;
  background-color: $dark;
  transition: 0.5s opacity ease;

  .wrapper {
    text-align: center;
  }
}

svg {
  fill: black;
  width: 20%;
  min-width: 250px;
  transition: 5s fill ease;
}

.blink {
  animation: blink 1300ms ease-in 2s infinite alternate;
}

@keyframes blink {
  to {
    opacity: 0.1;
  }
}
</style>
